import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { BaseService } from '../../core';
import { LoginRequest } from './request/login.request';
import { LoginResponse } from './response/login.response';
import { ResetSenhaRequest } from './request/reset-senha.request';
import { map, take, catchError } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { TokenVO } from 'app/shared/models/core';
import { ChangePasswordRequest } from './response/change-password.request';

@Injectable({ providedIn: 'root' })
export class LoginService extends BaseService {
  private loginEndpoint = `${environment.urlEdducaImobApi}EdducaImobCore/Login/`;

  constructor(private http: HttpClient) {
    super();
  }

  login(request: LoginRequest): Observable<TokenVO> {
    return this.http.post<TokenVO>(this.loginEndpoint, request, { headers: this.getHeader(true) })
  }

  resetPassword(email: string): Observable<boolean> {
    return this.http.put<boolean>(`${this.loginEndpoint}ResetPassword/${email}`, { headers: this.getHeader(true) });
  }

  renewPassword(request: ChangePasswordRequest): Observable<TokenVO> {
    return this.http.put<TokenVO>(`${this.loginEndpoint}RenewPassword`, request, { headers: this.getHeader(true) });
  }

  validateToken(): Observable<boolean> {
    return this.http.get(`${this.loginEndpoint}ValidateToken`, {
      headers: this.getHeader(true),
      observe: 'response',
      responseType: 'text' as 'json',
    }).pipe(
      map(() => true),
      take(1),
      catchError(() => of(false))
    );
  }
}
